import Customers from '@/views/Customers/Index'
import CustomersCustomers from '@/views/Customers/Customers/Index'
import CustomersCustomersCustomer from '@/views/Customers/Customers/Customer'

export default [
    {
        path: '/customers',
        name: 'customers',
        component: Customers,
        meta: {
            title: 'Klienci',
            menuRendered: true,
            menuTitle: 'Klienci',
            requiresAuth: true,
            permission: 'customers',
            icon: 'mdi-account-group',
        },
        redirect: { name: 'customersCustomers' },
        children: [
            {
                path: '/customers/customers',
                name: 'customersCustomers',
                component: CustomersCustomers,
                meta: {
                    title: 'Klienci',
                    requiresAuth: true,
                    permission: 'customers_read',
                },
            },
            {
                path: '/customers/customers/create',
                name: 'customersCustomersCreate',
                component: CustomersCustomersCustomer,
                meta: {
                    title: 'Klienci / Nowy klient',
                    requiresAuth: true,
                    permission:  'customers_create'
                },
            },
            {
                path: '/customers/customers/edit/:id',
                name: 'customersCustomersEdit',
                component: CustomersCustomersCustomer,
                meta: {
                    title: 'Klienci / Edycja klienta',
                    requiresAuth: true,
                    permission:  'customers_read'
                },
            },
        ],
    },
]